import React, { useState } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';
import { useToast } from '../hooks/use-toast';

const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '\u{1f1fa}\u{1f1f8}' },
  { code: '+44', country: 'UK', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', country: 'India', flag: '\u{1f1ee}\u{1f1f3}' },
  { code: '+86', country: 'China', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', country: 'Japan', flag: '\u{1f1ef}\u{1f1f5}' },
  { code: '+49', country: 'Germany', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', country: 'France', flag: '\u{1f1eb}\u{1f1f7}' },
  { code: '+39', country: 'Italy', flag: '\u{1f1ee}\u{1f1f9}' },
  { code: '+61', country: 'Australia', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', country: 'Brazil', flag: '\u{1f1e7}\u{1f1f7}' },
  { code: '+52', country: 'Mexico', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+82', country: 'South Korea', flag: '\u{1f1f0}\u{1f1f7}' },
  { code: '+34', country: 'Spain', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+31', country: 'Netherlands', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+46', country: 'Sweden', flag: '\u{1f1f8}\u{1f1ea}' },
  { code: '+41', country: 'Switzerland', flag: '\u{1f1e8}\u{1f1ed}' },
  { code: '+65', country: 'Singapore', flag: '\u{1f1f8}\u{1f1ec}' },
  { code: '+971', country: 'UAE', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+966', country: 'Saudi Arabia', flag: '\u{1f1f8}\u{1f1e6}' },
  { code: '+27', country: 'South Africa', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+64', country: 'New Zealand', flag: '\u{1f1f3}\u{1f1ff}' },
  { code: '+48', country: 'Poland', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+90', country: 'Turkey', flag: '\u{1f1f9}\u{1f1f7}' },
  { code: '+62', country: 'Indonesia', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', country: 'Philippines', flag: '\u{1f1f5}\u{1f1ed}' },
  { code: '+66', country: 'Thailand', flag: '\u{1f1f9}\u{1f1ed}' },
  { code: '+60', country: 'Malaysia', flag: '\u{1f1f2}\u{1f1fe}' },
  { code: '+84', country: 'Vietnam', flag: '\u{1f1fb}\u{1f1f3}' },
  { code: '+92', country: 'Pakistan', flag: '\u{1f1f5}\u{1f1f0}' },
  { code: '+880', country: 'Bangladesh', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+234', country: 'Nigeria', flag: '\u{1f1f3}\u{1f1ec}' },
  { code: '+254', country: 'Kenya', flag: '\u{1f1f0}\u{1f1ea}' },
  { code: '+353', country: 'Ireland', flag: '\u{1f1ee}\u{1f1ea}' },
  { code: '+43', country: 'Austria', flag: '\u{1f1e6}\u{1f1f9}' },
  { code: '+32', country: 'Belgium', flag: '\u{1f1e7}\u{1f1ea}' },
  { code: '+45', country: 'Denmark', flag: '\u{1f1e9}\u{1f1f0}' },
  { code: '+358', country: 'Finland', flag: '\u{1f1eb}\u{1f1ee}' },
  { code: '+30', country: 'Greece', flag: '\u{1f1ec}\u{1f1f7}' },
  { code: '+972', country: 'Israel', flag: '\u{1f1ee}\u{1f1f1}' },
  { code: '+56', country: 'Chile', flag: '\u{1f1e8}\u{1f1f1}' },
  { code: '+57', country: 'Colombia', flag: '\u{1f1e8}\u{1f1f4}' },
  { code: '+54', country: 'Argentina', flag: '\u{1f1e6}\u{1f1f7}' },
  { code: '+974', country: 'Qatar', flag: '\u{1f1f6}\u{1f1e6}' },
  { code: '+965', country: 'Kuwait', flag: '\u{1f1f0}\u{1f1fc}' },
  { code: '+852', country: 'Hong Kong', flag: '\u{1f1ed}\u{1f1f0}' },
  { code: '+886', country: 'Taiwan', flag: '\u{1f1f9}\u{1f1fc}' },
  { code: '+7', country: 'Russia', flag: '\u{1f1f7}\u{1f1fa}' },
  { code: '+20', country: 'Egypt', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+212', country: 'Morocco', flag: '\u{1f1f2}\u{1f1e6}' },
  { code: '+351', country: 'Portugal', flag: '\u{1f1f5}\u{1f1f9}' },
  { code: '+36', country: 'Hungary', flag: '\u{1f1ed}\u{1f1fa}' },
  { code: '+420', country: 'Czech Republic', flag: '\u{1f1e8}\u{1f1ff}' },
  { code: '+40', country: 'Romania', flag: '\u{1f1f7}\u{1f1f4}' },
  { code: '+380', country: 'Ukraine', flag: '\u{1f1fa}\u{1f1e6}' },
  { code: '+98', country: 'Iran', flag: '\u{1f1ee}\u{1f1f7}' },
  { code: '+51', country: 'Peru', flag: '\u{1f1f5}\u{1f1ea}' },
  { code: '+593', country: 'Ecuador', flag: '\u{1f1ea}\u{1f1e8}' },
  { code: '+968', country: 'Oman', flag: '\u{1f1f4}\u{1f1f2}' },
  { code: '+973', country: 'Bahrain', flag: '\u{1f1e7}\u{1f1ed}' },
  { code: '+94', country: 'Sri Lanka', flag: '\u{1f1f1}\u{1f1f0}' },
  { code: '+977', country: 'Nepal', flag: '\u{1f1f3}\u{1f1f5}' },
  { code: '+233', country: 'Ghana', flag: '\u{1f1ec}\u{1f1ed}' },
  { code: '+213', country: 'Algeria', flag: '\u{1f1e9}\u{1f1ff}' },
  { code: '+216', country: 'Tunisia', flag: '\u{1f1f9}\u{1f1f3}' },
  { code: '+961', country: 'Lebanon', flag: '\u{1f1f1}\u{1f1e7}' },
  { code: '+962', country: 'Jordan', flag: '\u{1f1ef}\u{1f1f4}' },
  { code: '+964', country: 'Iraq', flag: '\u{1f1ee}\u{1f1f6}' },
  { code: '+993', country: 'Turkmenistan', flag: '\u{1f1f9}\u{1f1f2}' },
  { code: '+58', country: 'Venezuela', flag: '\u{1f1fb}\u{1f1ea}' },
  { code: '+47', country: 'Norway', flag: '\u{1f1f3}\u{1f1f4}' },
  { code: '+853', country: 'Macau', flag: '\u{1f1f2}\u{1f1f4}' },
];

const HeroBanner = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({ name: '', email: '', countryCode: '+1', phone: '', description: '' });
  const [errors, setErrors] = useState({ email: '', phone: '' });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = { email: '', phone: '' };
    let hasErrors = false;
    if (!validateEmail(formData.email)) { newErrors.email = 'Enter a valid email address'; hasErrors = true; }
    if (formData.phone.length !== 10) { newErrors.phone = 'Phone must be exactly 10 digits'; hasErrors = true; }
    if (hasErrors) { setErrors(newErrors); return; }
    toast({ title: "Request Received!", description: "Our trademark experts will be in touch within 24 hours." });
    setFormData({ name: '', email: '', countryCode: '+1', phone: '', description: '' });
    setErrors({ email: '', phone: '' });
  };

  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1729932989176-6d905172c123?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXJrJTIwYnJvd24lMjBsaWJyYXJ5JTIwYm9va3NoZWx2ZXMlMjBvZmZpY2V8ZW58MHx8fHwxNzc1NTE1ODQ5fDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1C]/95 via-[#0A0F1C]/75 to-[#0A0F1C]/40" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10 w-full">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left - 7 cols */}
          <div className="lg:col-span-7 space-y-8">
            <div>
              <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#60A5FA] mb-5" style={{textShadow: '0 2px 8px rgba(0,0,0,0.5)'}}>
                US Trademark Registration Experts
              </p>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.1] text-white" style={{textShadow: '0 2px 12px rgba(0,0,0,0.4)'}}>
                Your Brand.
                <br />
                <span className="text-[#60A5FA]">Our Protection.</span>
              </h1>
            </div>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-xl">
              <strong className="text-white">Trademark Logo Design</strong> files, monitors, and secures your trademark with the USPTO. From initial search to final certificate, our attorneys handle every detail so you can focus on growing your business.
            </p>
            <div className="grid sm:grid-cols-2 gap-3">
              {['Federal protection in all 50 states', 'Expert USPTO filing & monitoring', 'Amazon Brand Registry enrollment', 'Dedicated attorney support'].map((item, i) => (
                <div key={i} className="flex items-center gap-3 group">
                  <div className="w-5 h-5 border border-[#002FA7]/50 group-hover:border-[#002FA7] group-hover:bg-[#002FA7]/10 flex items-center justify-center flex-shrink-0 transition-all duration-300">
                    <Check className="w-3 h-3 text-[#002FA7]" />
                  </div>
                  <span className="text-sm text-gray-400 group-hover:text-gray-200 transition-colors duration-300">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - 5 cols: Form */}
          <div className="lg:col-span-5" data-testid="hero-contact-form">
            <div className="bg-white/95 backdrop-blur-md border border-gray-200/60 p-8 md:p-9 shadow-[0_20px_60px_rgba(0,0,0,0.15)]">
              <div className="mb-6">
                <span className="inline-block bg-[#002FA7] text-white px-3 py-1 text-[10px] font-medium uppercase tracking-widest mb-4">
                  Starting at $49
                </span>
                <h3 className="text-2xl font-bold tracking-tight text-[#0A0F1C]">Register Your Trademark</h3>
                <p className="text-sm text-[#4B5563] mt-1">File with the USPTO and secure your brand nationwide</p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-3.5">
                <div>
                  <Label htmlFor="hero-name" className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Full Name *</Label>
                  <Input id="hero-name" data-testid="hero-name-input" placeholder="Enter your full name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="h-10 rounded-none border-[#E5E7EB] bg-[#F8F9FA] focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 mt-1" />
                </div>
                <div>
                  <Label htmlFor="hero-email" className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Email *</Label>
                  <Input id="hero-email" data-testid="hero-email-input" type="email" placeholder="your@email.com" value={formData.email} onChange={(e) => { setFormData({ ...formData, email: e.target.value }); setErrors({ ...errors, email: '' }); }} required className={`h-10 rounded-none bg-[#F8F9FA] mt-1 ${errors.email ? 'border-[#FF2A00]' : 'border-[#E5E7EB]'} focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20`} />
                  {errors.email && <p className="text-[#FF2A00] text-xs mt-1">{errors.email}</p>}
                </div>
                <div>
                  <Label htmlFor="hero-phone" className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Phone *</Label>
                  <div className="flex gap-2 mt-1">
                    <Select value={formData.countryCode} onValueChange={(v) => setFormData({ ...formData, countryCode: v })}>
                      <SelectTrigger data-testid="hero-country-select" className="w-[110px] h-10 rounded-none border-[#E5E7EB] bg-[#F8F9FA] focus:border-[#002FA7]"><SelectValue /></SelectTrigger>
                      <SelectContent className="max-h-[300px]">{countryCodes.map((item) => (<SelectItem key={item.code} value={item.code}><span className="flex items-center gap-2"><span>{item.flag}</span><span>{item.code}</span></span></SelectItem>))}</SelectContent>
                    </Select>
                    <Input id="hero-phone" data-testid="hero-phone-input" type="tel" placeholder="1234567890" value={formData.phone} onChange={(e) => { const d = e.target.value.replace(/\D/g, ''); if (d.length <= 10) { setFormData({ ...formData, phone: d }); setErrors({ ...errors, phone: '' }); } }} required maxLength={10} className={`flex-1 h-10 rounded-none bg-[#F8F9FA] ${errors.phone ? 'border-[#FF2A00]' : 'border-[#E5E7EB]'} focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20`} />
                  </div>
                  {errors.phone && <p className="text-[#FF2A00] text-xs mt-1">{errors.phone}</p>}
                </div>
                <div>
                  <Label htmlFor="hero-desc" className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">What do you need?</Label>
                  <Textarea id="hero-desc" data-testid="hero-description-input" placeholder="e.g. Register my brand for Amazon Brand Registry" rows={2} value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="rounded-none border-[#E5E7EB] bg-[#F8F9FA] focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 resize-none mt-1" />
                </div>
                <Button type="submit" data-testid="hero-contact-submit" className="w-full bg-[#002FA7] hover:bg-[#002280] text-white h-11 text-sm font-medium rounded-none transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,47,167,0.3)]">
                  Get My Free Consultation <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
                <p className="text-[10px] text-[#4B5563] text-center">By submitting, you agree to our Terms of Service and Privacy Policy.</p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
